<btn
    [id]="id()"
    [severity]="severity()"
    [label]="label() | translate"
    [icon]="icon() || 'fa-solid fa-times'"
    [text]="text()"
    [rounded]="rounded()"
    [outlined]="outlined()"
    [loading]="loading()"
    [disabled]="disabled()"
    [class.w-100]="fullWidth()"
    (onClick)="openPopconfirm($event)"></btn>

<p-confirmpopup [id]="id() + '-popup'" [key]="id() + '-btn'" />
